import type { AccountStatus } from '@repo/api-contracts';

/**
 * 로그인 · 가입 · 소셜 인증 직후 계정 상태에 따른 목적지.
 *
 * 소셜 로그인의 성공 응답은 "로그인 완료"가 아니라 "온보딩 진입"일 수 있다 —
 * 프론트는 세션의 상태를 보고 라우팅해야 한다. (설계 §2-3)
 */
export const routeForStatus = (status: AccountStatus): string => {
  switch (status) {
    case 'PENDING_EMAIL':
    case 'PENDING_IDENTITY':
      return '/onboarding';
    default:
      return '/';
  }
};
